let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7RSYT")).then(() => parcelRequire('6Hnkk'));